import style from './anmSelectQuery.module.scss';
import { BrButton, BrLoading, BrSelect } from '@govbr-ds/react-components';
import { SelectOptions } from '@govbr-ds/react-components/dist/components/BrSelect';
import { useQuery } from '@tanstack/react-query';
import { IErrorWithSentryId } from 'interfaces/IErrorWithSentryId';
import { useEffect, useId, useState } from 'react';

interface IAnmSelectQueryProps {
  label: string;
  value: string;
  setValue: Function;
  functionQuery: Function;
  keyQuery: any[];
  formatResult?: Function;
  placeholder?: string;
  errorMessage?: string;
  id?: string;
}

const AnmSelectQuery = ({
  label,
  value,
  setValue,
  functionQuery,
  keyQuery,
  formatResult,
  placeholder = 'Selecionar',
  errorMessage = 'Não foi possível carregar os dados',
  id,
}: IAnmSelectQueryProps) => {
  const [selectOptions, setSelectOptions] = useState<SelectOptions[]>([]);

  const componentId = useId();
  const testId = id ?? `anm-select-query-${componentId}`;

  const {
    data: queryResult,
    isLoading,
    error: queryError,
    refetch: refetchQuery,
  } = useQuery<any[], IErrorWithSentryId>({
    queryKey: keyQuery,
    queryFn: () => functionQuery(),
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    let options = [];

    if (queryResult == undefined) {
      return;
    }

    if (formatResult) {
      options = formatResult(queryResult);
    } else {
      options = queryResult.map((value) => ({
        label: value.toString(),
        value: value.toString(),
      }));
    }

    setSelectOptions(options);
  }, [queryResult, queryError]);

  return (
    <div className={style.anmSelectContainer}>
      {isLoading === true && <BrLoading />}
      {queryError == null && isLoading === false && (
        <BrSelect
          label={label}
          id={testId}
          data-testid={testId}
          key={value}
          className={style.select}
          placeholder={placeholder}
          value={value}
          onChange={(value: string) => {
            setValue(value);
          }}
          options={selectOptions}
          disabled={false}
        />
      )}
      {queryError && (
        <div className={style.errorContainer}>
          <span className={style.errorText}>{errorMessage}</span>
          <BrButton size='small' onClick={() => refetchQuery()}>
            (Tentar novamente)
          </BrButton>
        </div>
      )}
    </div>
  );
};

export default AnmSelectQuery;
